/* @flow weak */
import Button from 'components/Button.jsx';
import Columns2 from 'components/Columns2.jsx';
import CurrentUser from 'auth/CurrentUser';
import Fieldset from 'components/Fieldset.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import React from 'react';
import SettingsContainer from './SettingsContainer.jsx';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

const UserPasswordForm = React.createClass({
  getInitialState() {
    return {
      user: CurrentUser.isSignedIn() ? CurrentUser.getUser() : null,
      canSubmit: false,
    };
  },

  disableButton() {
    this.setState({ canSubmit: false });
  },

  enableButton() {
    this.setState({ canSubmit: true });
  },

  submit(values: Object) {
    UserActions.changePassword(values.current_password, values.password)
    .then(() => ToastActions.showSuccessToast('Password has been changed!'))
    .catch(ToastActions.showDefaultErrorToast);
  },

  render() {
    return (
      <Form
        onValid={this.enableButton}
        onValidSubmit={this.submit}
        onInvalid={this.disableButton}>
        <Fieldset legend="Password">
          <SettingsContainer>
            <Columns2>
              <div>
                <FormInput
                  label="Current password"
                  type="password"
                  className="UserPasswordForm-password"
                  name="current_password"
                  validations="minLength:6"
                  validOnPristine
                  validationError="Password must be at least 6 characters long."
                />
              </div>
            </Columns2>
            <Columns2>
              <div>
                <FormInput
                  label="New password"
                  type="password"
                  autoComplete="new-password"
                  className="UserPasswordForm-password"
                  name="password"
                  required
                  validations="minLength:6"
                  validOnPristine
                  validationError="Password must be at least 6 characters long."
                />
              </div>

              <div>
                <FormInput
                  label="Retype password"
                  type="password"
                  autoComplete="new-password"
                  className="UserPasswordForm-password"
                  name="password_confirmation"
                  validations="equalsField:password"
                  validationError="Must be same as password"
                  validOnPristine
                />
              </div>
            </Columns2>
          </SettingsContainer>

          <Button
            size="small"
            type="submit"
            disabled={!this.state.canSubmit}>
            Save
          </Button>
        </Fieldset>
      </Form>
    );
  },
});

export default UserPasswordForm;



// WEBPACK FOOTER //
// ./src/settings/components/UserPasswordForm.jsx